import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const PortAudioIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_309"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_309)">
        <path
          d="M7.06666 2.40075L6.73628 2.07037C6.69298 2.11379 6.65865 2.16531 6.63527 2.222C6.61189 2.27869 6.59992 2.33943 6.60003 2.40075H7.06666ZM7.99994 1.46747L8.33032 1.13709C8.28698 1.09364 8.23548 1.05916 8.17879 1.03563C8.1221 1.01211 8.06132 1 7.99994 1C7.93856 1 7.87779 1.01211 7.82109 1.03563C7.7644 1.05916 7.71291 1.09364 7.66956 1.13709L7.99994 1.46747ZM8.93322 2.40075H9.39986C9.39997 2.33943 9.38799 2.27869 9.36461 2.222C9.34123 2.16531 9.30691 2.11379 9.2636 2.07037L8.93322 2.40075ZM7.06666 9.40033H8.93322V8.46706H7.06666V9.40033ZM9.39986 9.86697V12.6668H10.3331V9.86697H9.39986ZM8.93322 13.1334H7.06666V14.0667H8.93322V13.1334ZM6.60003 12.6668V9.86697H5.66675V12.6668H6.60003ZM7.06666 13.1334C6.9429 13.1334 6.82421 13.0843 6.7367 12.9968C6.64919 12.9093 6.60003 12.7906 6.60003 12.6668H5.66675C5.66675 13.0381 5.81424 13.3942 6.07677 13.6567C6.33931 13.9192 6.69538 14.0667 7.06666 14.0667V13.1334ZM9.39986 12.6668C9.39986 12.7906 9.3507 12.9093 9.26318 12.9968C9.17567 13.0843 9.05698 13.1334 8.93322 13.1334V14.0667C9.3045 14.0667 9.66058 13.9192 9.92311 13.6567C10.1856 13.3942 10.3331 13.0381 10.3331 12.6668H9.39986ZM8.93322 9.40033C9.05698 9.40033 9.17567 9.4495 9.26318 9.53701C9.3507 9.62452 9.39986 9.74321 9.39986 9.86697H10.3331C10.3331 9.49569 10.1856 9.13962 9.92311 8.87708C9.66058 8.61455 9.3045 8.46706 8.93322 8.46706V9.40033ZM7.06666 8.46706C6.69538 8.46706 6.33931 8.61455 6.07677 8.87708C5.81424 9.13962 5.66675 9.49569 5.66675 9.86697H6.60003C6.60003 9.74321 6.64919 9.62452 6.7367 9.53701C6.82421 9.4495 6.9429 9.40033 7.06666 9.40033V8.46706ZM7.5333 8.93369V4.26731H6.60003V8.93369H7.5333ZM7.06666 4.73394H8.93322V3.80067H7.06666V4.73394ZM8.46658 4.26731V8.93369H9.39986V4.26731H8.46658ZM7.5333 13.1334V15H8.46658V13.1334H7.5333ZM7.5333 4.26731V2.40075H6.60003V4.26731H7.5333ZM7.39705 2.73113L8.33032 1.79785L7.66956 1.13709L6.73628 2.07037L7.39705 2.73113ZM7.66956 1.79785L8.60284 2.73113L9.2636 2.07037L8.33032 1.13709L7.66956 1.79785ZM8.46658 2.40075V4.26731H9.39986V2.40075H8.46658Z"
          fill={color}
        />
        <path
          d="M7.11652 5.7065H8.85767V6.62854H7.11652V5.7065Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortAudioIcon.displayName = "PortAudioIcon";
